import { render, staticRenderFns } from "./TableData.vue?vue&type=template&id=d9443352&scoped=true&"
import script from "./TableData.vue?vue&type=script&lang=js&"
export * from "./TableData.vue?vue&type=script&lang=js&"
import style0 from "./TableData.vue?vue&type=style&index=0&id=d9443352&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9443352",
  null
  
)

export default component.exports